import { useEffect, useRef, useState } from 'react'

import { TypeWriterProps } from './typeWriter.types';
import { STEP_SPEED } from './typeWriter.constants';

const TypeWriter = ({ text, letterSpeed = STEP_SPEED, onFinishTyping }: TypeWriterProps) => {
    const currentLetter = useRef(-1)
    const [typewriter, setTypewriter] = useState('')

    useEffect(() => {
        const timer = setTimeout(() => {
            setTypewriter((prev) =>  prev + text.charAt(currentLetter.current))
        }, letterSpeed)

        return () => {
            clearTimeout(timer)
        }
    }, [text, typewriter])

    useEffect(() => {
        if (currentLetter.current < text.length) {
          currentLetter.current += 1
        }

        if (currentLetter.current === text.length) {
          onFinishTyping?.()
        }

    }, [typewriter, onFinishTyping])

    return <span>{typewriter}</span>
}

export default TypeWriter;
